import { render } from "./RegisterStep8.vue?vue&type=template&id=38f41f7b&scoped=true"
import script from "./RegisterStep8.vue?vue&type=script&lang=js"
export * from "./RegisterStep8.vue?vue&type=script&lang=js"

import "./RegisterStep8.vue?vue&type=style&index=0&id=38f41f7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f41f7b"]])

export default __exports__